import React from "react";
import { withRouter } from "react-router";
import queryString from "query-string";
export class UrlQueryParamModifier extends React.Component {
    constructor(props) {
        super(props);
        this.modifyUrlQueryParam = this.modifyUrlQueryParam.bind(this);
    }
    modifyUrlQueryParam(newQueryParams) {
        const queryParams = Object.assign(this.props.location.query, newQueryParams.toJS());
        this.props.router.replace({
            pathname: this.props.location.pathname,
            search: `?${queryString.stringify(queryParams)}`
        });
    }
    render() {
        return this.props.render({ onClick: (queryParams) => this.modifyUrlQueryParam(queryParams) });
    }
}
export default withRouter(UrlQueryParamModifier);
